import { useState, useEffect, useCallback } from "react";
import supplierTransactionService from "../services/supplierTransactionService";

const DEFAULT_FILTERS = {
  SupplierName: "",
  From: "",
  To: "",
  SearchTerm: "",
  PageIndex: 1,
  PageSize: 10,
};

const useSupplierTransaction = () => {
  const [items, setItems] = useState([]);
  const [balances, setBalances] = useState([]);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchList = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await supplierTransactionService.getAll(filters);
      setItems(res?.data || []);
      setPagination({
        totalCount: res?.totalCount || 0,
        totalPages: res?.totalPages || 1,
        currentPage: res?.currentPage || 1,
        hasNextPage: res?.hasNextPage || false,
        hasPreviousPage: res?.hasPreviousPage || false,
      });
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const fetchBalances = useCallback(async () => {
    try {
      const res = await supplierTransactionService.getBalances();
      setBalances(res?.data || []);
    } catch (err) {
      console.error("فشل جلب أرصدة الموردين:", err);
    }
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  useEffect(() => {
    fetchBalances();
  }, [fetchBalances]);

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters, PageIndex: 1 }));
  };

  const goToPage = (page) => {
    setFilters((prev) => ({ ...prev, PageIndex: page }));
  };

  const addItem = async (payload, setFieldError) => {
    const created = await supplierTransactionService.create(payload, setFieldError);
    if (created) await Promise.all([fetchList(), fetchBalances()]);
    return created;
  };

  const editItem = async (id, payload, setFieldError) => {
    const updated = await supplierTransactionService.update(id, payload, setFieldError);
    if (updated) await Promise.all([fetchList(), fetchBalances()]);
    return updated;
  };

  const deleteItem = async (id) => {
    await supplierTransactionService.remove(id);
    await Promise.all([fetchList(), fetchBalances()]);
  };

  return {
    items,
    balances,
    filters,
    pagination,
    loading,
    error,
    updateFilters,
    goToPage,
    addItem,
    editItem,
    deleteItem,
  };
};

export default useSupplierTransaction;